module.exports = "/images/vendor/photoswipe/dist/default-skin/default-skin.png?e3f799c6dec9af194c86decdf7392405";


//////////////////
// WEBPACK FOOTER
// ./node_modules/photoswipe/dist/default-skin/default-skin.png
// module id = G5Aw
// module chunks = 1 2 4 5 15 17 18 19